import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum CancellationServiceAction {
  CREATE_CANCELLATION_TICKET = "CREATE_CANCELLATION_TICKET",
  UPLOAD_IMAGE = "UPLOAD_IMAGE_CANCELLATION",
  CLEAN_UP = "CLEAN_UP_CANCELLATION_SERVICE",
  UPDATE_STATE = "UPDATE_STATE_CANCELLATION_SERVICE",
}

interface PurchaseDetails {
  invoice: string;
  date_of_purchase: string;
  store_name: string;
  store_phone: string;
  store_address: string;
  store_city: string;
  store_state: string;
  were_any_items_exchanged: string;
  store_zip: string;
}

interface CustomerDetails {
  name: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
}

interface Documents {
  invoice: [string?];
}

export interface CancellationServiceState {
  documents: Documents;
  purchaseDetails: PurchaseDetails;
  customerDetails: CustomerDetails;
  cancellation_reason: string;
}

export type CancellationServiceTypes = ReturnType<
  InferValueTypes<typeof actions>
>;

export const CancellationServiceScope = "cancellation-service";
